import { Box, FormControlLabel, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RoutePath } from 'RoutePath';
import { StoreImageControlField } from 'components/CoverImageControl/StoreImageControl';
import { CropperMode } from 'components/CoverImageControl/types';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { FormAddress } from 'components/FormAddress/FormAddress';
import { FormErrorMessage } from 'components/FormErrorMessage/FormErrorMessage';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { FullScreenLoader } from 'components/Loader/Loader';
import { SelectEnumControlField } from 'components/SelectEnumControl/SelectEnumControl';
import { TranslatableEnum } from 'components/T/GetTranslationForEnum';
import { TagControlField } from 'components/TagControl/TagControl';
import { Text, TextTypography } from 'components/Text/Text';
import { TextAreaControlField } from 'components/TextAreaControl/TextAreaControl';
import { TextControlField } from 'components/TextControl/TextControl';
import { WorkingHoursControlField } from 'components/WorkingHoursControl/WorkingHoursControl';
import { daysOfWeek, formatISOTime } from 'core/date/date';
import { useFormError, validator } from 'core/form/form';
import { useAction, useActionDispatchOnMount, useActivate } from 'core/store/store';
import { customUrlValidator, makeAddressValidator } from 'core/validators/validators';
import { Form } from 'forms/types';
import { Schedule } from 'pages/Store/components/StoreSchedule';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import i18n from '../../../i18n';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { isUIEnabledSelector } from 'state/app/selectors';
import { StoreDetailsActionType } from 'state/storeDetails/actions';
import { WorkingHoursForDay } from 'state/storeDetails/types';
import { UserMenuSlice } from 'state/userMenu/reducer';
import { AddressDto, CroppedArea, NotificationType, StoreCategory, SupportedCountryCodes } from 'types';
import { string } from 'yup';
import { GalleryControlField } from 'components/Gallery/GalleryControlField';
import { GalleryItem } from 'components/Gallery/types';
import { authIsoCodeSelector, authStoreIdSelector, authStoreOpenForOrdersSelector } from 'state/auth/selectors';
import {
    authorizeInstagram,
    connectInstagram,
    getConnectedInstagram,
    getInstagramPosts,
    updateInstagramPosts,
} from 'core/instagram/instagram';
import { InstagramGallery, InstagramPost } from 'components/InstagramGallery/InstagramGallery';
import { env } from 'env';
import { SwitchControl } from 'components/SwitchControl/SwitchControl';
import { makeAuthChangeOpenForOrdersAction } from 'state/auth/actions';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { userMenuProfileSelector } from 'state/userMenu/selector';
import { makeRegistrationStoreSettingsFetchAction } from 'state/registration/actions';
import { RichTextControlField } from 'components/RichTextControl/RichTextControl';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import browserCookies from 'browser-cookies';
import { getClientUrl } from 'core/utils/utils';

const isServer = typeof window === 'undefined';

export enum ShopTabs {
    SHOP = 'SHOP',
    GALLERY = 'GALLERY',
    PAY_DELIVERY = 'PAYDELIVERY',
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
    },
    header: {
        flexGrow: 0,
        flexBasis: 'auto',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: 800,
        margin: 'auto',
        marginTop: ({ country }: { country: string; isCreateMode: boolean }) =>
            country === SupportedCountryCodes.RUS ? 56 : 0,
        [theme.breakpoints.down(960)]: {
            padding: theme.spacing(0, 5),
            // paddingLeft: 40,
        },
        [theme.breakpoints.down(640)]: {
            padding: theme.spacing(0, 3),
            marginTop: theme.spacing(14),
        },
        [theme.breakpoints.down(768)]: {
            paddingBottom: ({ isCreateMode }: { isCreateMode: boolean }) => !isCreateMode && 120,
        },
        [theme.breakpoints.down(480)]: {
            padding: 0,
        },
        paddingBottom: ({ isCreateMode }: { isCreateMode: boolean }) => !isCreateMode && 130,
    },
    contentPay: {
        maxWidth: 800,
        margin: '0 auto',
    },
    contentInfo: {
        maxWidth: 800,
        margin: 'auto',
        flex: 1,
        [theme.breakpoints.up(640)]: {
            boxShadow: '0px 0px 50px rgba(15, 24, 37, 0.05)',
            borderRadius: 20,
            padding: theme.spacing(3),
            marginTop: theme.spacing(3),
        },
    },
    field: {
        paddingBottom: theme.spacing(3),
    },
    wysiwygField: {
        paddingBottom: theme.spacing(3),
        width: '100%',
    },
    fieldAddImage: {
        paddingBottom: theme.spacing(2),
        textAlign: 'center',
        maxWidth: '85%',
        margin: '0 auto',
    },
    fieldCoverImage: {
        paddingBottom: theme.spacing(2),
        marginTop: 32,
    },
    switchControl: {
        paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
        switchControl: {
            paddingTop: 6,
        },
    },
    footerInfo: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        zIndex: 1,
        background: '#fafafa',
        [theme.breakpoints.down(640)]: {
            padding: theme.spacing(0, 0, 8),
        },
    },
    editSubmit: {
        maxWidth: 800,
        margin: 'auto',
        padding: theme.spacing(3, 0),
        // paddingTop: theme.spacing(3),
        // paddingBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fafafa',
        [theme.breakpoints.down(960)]: {
            padding: theme.spacing(3, 5),
        },
        [theme.breakpoints.down(640)]: {
            padding: theme.spacing(3),
        },
        [theme.breakpoints.down(480)]: {
            padding: theme.spacing(2, 2),
        },
    },
    editHeader: {
        position: 'fixed',
        backgroundColor: '#fafafa',
        top: 0,
        width: '100%',
        display: 'flex',
        padding: theme.spacing(2.5),
        borderBottom: `1px solid ${theme.palette.brandPrimary.accent}`,
        zIndex: 2, //check vendor menu for desktop
        [theme.breakpoints.up(640)]: {
            display: 'none',
        },
        [theme.breakpoints.down(375)]: {
            padding: theme.spacing(2),
        },
    },
    editTitle: {
        paddingRight: theme.spacing(3),
        width: '100%',
        textAlign: 'center',
    },
    tabs: {
        width: '100%',
        backgroundColor: '#fafafa',
        paddingLeft: theme.spacing(30),

        [theme.breakpoints.down(1280)]: {
            paddingLeft: 80,
        },
        [theme.breakpoints.down(960)]: {
            paddingLeft: 40,
        },
        [theme.breakpoints.down(640)]: {
            paddingLeft: 24,
        },
        [theme.breakpoints.down(480)]: {
            paddingLeft: 16,
        },
    },
    tabsItem: {
        minWidth: 0,
        padding: 0,
        marginRight: 32,
        '& span': {
            paddingTop: 16,
            paddingBottom: 16,
        },
    },
    frame: {
        // width: '100%',
        height: '100%',
        position: 'relative',
        marginTop: theme.spacing(3),
        // marginRight: theme.spacing(3),
        padding: theme.spacing(3),
        boxShadow: '0px 0px 50px rgba(15, 24, 37, 0.05)',
        borderRadius: 20,
        [theme.breakpoints.down(640)]: {
            padding: theme.spacing(3),
        },
        [theme.breakpoints.down(480)]: {
            padding: theme.spacing(4, 2),
            borderRadius: 0,
            marginTop: 2,
        },
        '&:first-child': {
            marginTop: theme.spacing(4),
            [theme.breakpoints.down(480)]: {
                marginTop: 0,
            },
        },
    },
    frameGallery: {
        marginBottom: theme.spacing(2),
    },
    // frameInfo: {
    //     height: '100%',
    //     width: '100%',
    //     position: 'relative',
    //     padding: theme.spacing(2),
    // },
    imgClassName: {
        borderRadius: 20,
    },
    iconClickableContainer: {
        cursor: 'pointer',
    },

    hoursContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.brandPrimary.accent}`,
    },
    hoursContainerTitle: {
        width: '100%',
    },
    instagram: {
        textAlign: 'center',
        marginBottom: theme.spacing(3),
    },
    instagramButton: {
        margin: 'auto',
        marginBottom: 16,
        width: '50%',
        [theme.breakpoints.down(641)]: {
            width: '100%',
        },
    },
    line: {
        margin: theme.spacing(0, 'auto', 2, 'auto'),
    },
    workingHoursContainer: {
        marginRight: 0,
        minWidth: 'fit-content',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    storeScheduleContainer: {
        marginLeft: -24,
    },
    noOrders: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(3),
    },
    noOrdersControl: {
        display: 'flex',
    },
    noOrdersText: {
        marginTop: theme.spacing(3),
    },
    fieldClock: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.brandPrimary.accent}`,
    },
    fieldClockChange: {
        '& button': {
            padding: 0,
        },
    },
    infoContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        [theme.breakpoints.down(960)]: {
            flexDirection: 'column',
            width: '100%',
            '% first-child': {
                marginRight: 0,
            },
        },
    },
    infoBlock: {
        width: '48.5%',
        marginTop: theme.spacing(3),
        // marginRight: theme.spacing(3),
        padding: theme.spacing(3),
        boxShadow: '0px 0px 50px rgba(15, 24, 37, 0.05)',
        borderRadius: 20,
        '% first-child': {
            marginRight: theme.spacing(2),
        },
        [theme.breakpoints.down(960)]: {
            width: '100%',
            '% first-child': {
                marginRight: 0,
            },
        },
        [theme.breakpoints.down(480)]: {
            borderRadius: 0,
            marginTop: 2,
        },
    },
    linePhoto: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}));

const storeDetailsEditFormValueSelector = formValueSelector(Form.STORE_DETAILS_EDIT_FORM);

const mapStateToEditFormProps = (state: UserMenuSlice) => {
    const workingHours = storeDetailsEditFormValueSelector(state, 'workingHours');
    const coordinates = storeDetailsEditFormValueSelector(state, 'coordinates');

    const { storeInfo, storeNotificationSettings } = state.userMenu;
    const gallery: GalleryItem[] = (storeInfo as any)?.carousel?.map((item: any) => ({
        imageId: item.images[360],
        label: item.description,
        color: item.styles?.color,
        horizontalAlignment: item.styles?.textAlign,
        verticalAlignment: item.styles?.justifyContent,
    }));

    return {
        initialValues: {
            ...storeInfo,
            emailNotification:
                storeNotificationSettings?.find(
                    notificationSetting => notificationSetting.notificationMethod === NotificationType.EMAIL,
                )?.enabled || false,
            smsNotification:
                storeNotificationSettings?.find(
                    notificationSetting => notificationSetting.notificationMethod === NotificationType.PHONE,
                )?.enabled || false,
            gallery,
        },
        workingHours,
        coordinates,
    };
};

const inputSelector = (state: any) => {
    const shortDescription = storeDetailsEditFormValueSelector(state, 'shortDescription');
    const fullDescription = storeDetailsEditFormValueSelector(state, 'fullDescription');
    const advantages = storeDetailsEditFormValueSelector(state, 'advantages');
    const sellingDescription = storeDetailsEditFormValueSelector(state, 'sellingDescription');
    const sloganDescription = storeDetailsEditFormValueSelector(state, 'slogan');

    const shortDescriptionValue = shortDescription ? String(shortDescription).length : '0';
    const fullDescriptionValue = fullDescription ? String(fullDescription).length : '0';
    const advantagesValue = advantages ? String(advantages).length : '0';
    const sellingDescriptionValue = sellingDescription ? String(sellingDescription).length : '0';
    const sloganDescriptionValue = sloganDescription ? String(sloganDescription).length : '0';

    return {
        shortDescriptionValue,
        fullDescriptionValue,
        advantagesValue,
        sellingDescriptionValue,
        sloganDescriptionValue,
    };
};

const emailNotificationSelector = <T extends {}>(state: T) =>
    storeDetailsEditFormValueSelector(state, 'emailNotification') || false;

const smsNotificationSelector = <T extends {}>(state: T) =>
    storeDetailsEditFormValueSelector(state, 'smsNotification') || false;

const DefaultStoreDetailsForm = (props: any) => {
    useActivate(StoreDetailsActionType.ACTIVATE, StoreDetailsActionType.DEACTIVATE);
    const action = useAction();
    const history = useHistory();
    const { handleSubmit, form, initialValues, coordinates, workingHours } = props;
    const isCreateMode = form === Form.STORE_DETAILS_FORM;
    const { t } = i18n.useTranslation();
    const country = useSelector(authIsoCodeSelector) || SupportedCountryCodes.RUS;
    const classes = useStyles({ isCreateMode, country });
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const error = useFormError(form);
    const goToVendorDashboard = useCallback(() => history.push(RoutePath.VENDOR_DASHBOARD), [history]);

    const emailNotification = useSelector(emailNotificationSelector);
    const smsNotification = useSelector(smsNotificationSelector);

    const storeId = useSelector(authStoreIdSelector);

    const openForOrders = useSelector(authStoreOpenForOrdersSelector);

    const userProfile = useSelector(userMenuProfileSelector);

    const emailInfo = useMemo(() => userProfile?.email || t('onboarding:storeDetails.emptyEmailInfo'), [
        userProfile?.email,
        t,
    ]);

    const [isWAPhone, setIsWAPhone] = useState(false);
    const [phone, setPhone] = useState(initialValues?.phone);

    useEffect(() => {
        setIsWAPhone(!!initialValues?.waPhone);
    }, [initialValues?.waPhone, setIsWAPhone]);

    useEffect(() => {
        setPhone(initialValues?.phone);
    }, [initialValues?.phone, setPhone]);

    const handlePhoneChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setPhone(event.target.value);
        },
        [setPhone],
    );

    const handleChangePhoneWAStatus = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const { checked } = event.target;
            action(change, form, 'waPhone', checked);
            setIsWAPhone(checked);
        },
        [action],
    );

    const handleSwitchEmailNotification = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const { checked } = event.target;
            action(change, form, 'emailNotification', checked);
        },
        [action],
    );

    const handleSwitchSmsNotification = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const { checked } = event.target;
            action(change, form, 'smsNotification', checked);
        },
        [action],
    );

    const storeSchedule = useMemo(() => {
        return Object.keys((workingHours || {}) as WorkingHoursForDay[]).map((day: unknown) => {
            const item = workingHours[day as number];
            return {
                dayOfWeek: daysOfWeek[day as number],
                opens: formatISOTime(item.workingHoursFrom),
                closes: formatISOTime(item.workingHoursTo),
                timeBreak: item.breakEnabled
                    ? {
                          start: formatISOTime(item.breakFrom),
                          end: formatISOTime(item.breakTo),
                      }
                    : null,
            };
        });
    }, [workingHours]);

    const [hasInstagram, setHasInstagram] = useState(null);
    const [instagramPosts, setInstagramPosts] = useState<InstagramPost[] | null>(null);

    useEffect(() => {
        if (env.useInstagramFeature && storeId) {
            connectInstagram(storeId)
                .then(() => getConnectedInstagram(storeId))
                .then(hasInstagram => {
                    setHasInstagram(hasInstagram);
                    return getInstagramPosts(storeId);
                })
                .then(posts => {
                    setInstagramPosts(posts);
                })
                .catch();
        }
    }, [setHasInstagram, setInstagramPosts, storeId]);

    const handleUpdateInstagramPosts = useCallback(() => {
        updateInstagramPosts(storeId)
            .then(() => getInstagramPosts(storeId))
            .then(posts => {
                setInstagramPosts(posts);
            })
            .catch();
    }, [setInstagramPosts, storeId]);

    const handleOpenForOrdersChange = useCallback(
        isOpen => {
            action(makeAuthChangeOpenForOrdersAction, !isOpen);
        },
        [action],
    );

    const [idParams, setIdParams] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');

        if (id) {
            setIdParams(id);
        } else {
            setIdParams(false);
        }
    }, [idParams]);

    const inputs = useSelector(inputSelector);
    useActionDispatchOnMount(true, makeRegistrationStoreSettingsFetchAction);

    const handleStandardAddressChange = useCallback(
        (data: AddressDto) => {
            action(change, form, 'standardAddress', data);
        },
        [action, form],
    );

    if (initialValues || isCreateMode) {
        return (
            <ErrorBoundary>
                <form onSubmit={handleSubmit}>
                    <Grid container className={classes.content}>
                        <Grid item xs={12} className={classes.frame}>
                            <Text typography={TextTypography.TITLE_CHANGE}>{t('onboarding:storeDetails.orders')}</Text>
                            <div className={classes.noOrders}>
                                <div className={classes.noOrdersControl}>
                                    <SwitchControl
                                        label={''}
                                        value={!openForOrders}
                                        onChange={handleOpenForOrdersChange}
                                    />
                                    <div>
                                        <Text typography={TextTypography.PARA_ACCENT}>
                                            {t('onboarding:settings.noOrdersSwitch')}
                                        </Text>
                                    </div>
                                </div>
                                {!openForOrders && (
                                    <div className={classes.noOrdersText}>
                                        <Text typography={TextTypography.PARA_CHANGE}>
                                            {t('onboarding:settings.noOrdersText')}
                                        </Text>
                                    </div>
                                )}
                            </div>
                        </Grid>
                        <Grid item xs={12} className={classes.frame}>
                            <Box className={classes.frameGallery}>
                                <Text typography={TextTypography.TITLE_CHANGE}>
                                    {t('onboarding:storeDetails.gallery')}
                                </Text>
                            </Box>
                            <Field name="gallery" component={GalleryControlField} />
                        </Grid>
                        <div className={classes.infoContainer}>
                            <div className={classes.infoBlock}>
                                <Box mb={3}>
                                    <Text typography={TextTypography.TITLE_CHANGE}>
                                        {t('onboarding:storeDetails.storeInformation')}
                                    </Text>
                                </Box>

                                <div className={classes.field}>
                                    <Field
                                        name="name"
                                        component={TextControlField}
                                        label={t('onboarding:storeDetails.name')}
                                    />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="address"
                                        component={FormAddress}
                                        label={t('common:addressControl.streetAddress')}
                                        initWithGeolocationData={isCreateMode}
                                        initialCoordinates={initialValues.coordinates}
                                        value={initialValues.address}
                                        buttonText="OK"
                                        onCoordinatesChange={(coordinates: {
                                            lat: number;
                                            lon: number;
                                            qc_geo: number;
                                        }) => {
                                            action(change, form, 'coordinates', coordinates);
                                        }}
                                        onStandardAddressChange={handleStandardAddressChange}
                                        coordinates={coordinates}
                                        headerText={t('onboarding:addressDialog.enterShopAddress')}
                                    />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="phone"
                                        component={TextControlField}
                                        onChange={handlePhoneChange}
                                        label={t('onboarding:storeDetails.phone')}
                                    />
                                    <FormControlLabel
                                        value="waPhone"
                                        control={
                                            <Checkbox
                                                checked={isWAPhone}
                                                name="waPhone"
                                                onChange={handleChangePhoneWAStatus}
                                            />
                                        }
                                        label={
                                            <Text typography={TextTypography.PARA_CHANGE}>
                                                {t('onboarding:storeDetails.waPhone')}
                                            </Text>
                                        }
                                    />
                                    <div>
                                        <Text
                                            className={classes.notificationBlock}
                                            typography={TextTypography.PARA_CHANGE}
                                        >
                                            {t('onboarding:storeDetails.notificationInfo')}
                                        </Text>
                                    </div>
                                    <FormControlLabel
                                        value="emailNotification"
                                        disabled={!userProfile?.email}
                                        control={
                                            <Checkbox
                                                checked={emailNotification}
                                                name="emailNotification"
                                                onChange={handleSwitchEmailNotification}
                                            />
                                        }
                                        label={
                                            <Text
                                                typography={
                                                    userProfile?.email
                                                        ? TextTypography.PARA_CHANGE
                                                        : TextTypography.BODY_LIGHT
                                                }
                                            >
                                                {t('onboarding:storeDetails.emailNotification', {
                                                    emailInfo,
                                                })}
                                            </Text>
                                        }
                                    />
                                    <FormControlLabel
                                        value="smsNotification"
                                        control={
                                            <Checkbox
                                                checked={smsNotification}
                                                name="smsNotification"
                                                onChange={handleSwitchSmsNotification}
                                            />
                                        }
                                        label={
                                            <Text typography={TextTypography.PARA_CHANGE}>
                                                {t('onboarding:storeDetails.smsNotification', {
                                                    phoneInfo: phone,
                                                })}
                                            </Text>
                                        }
                                    />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="storeCategory"
                                        component={SelectEnumControlField}
                                        label={t('onboarding:storeDetails.storeCategory')}
                                        enum={TranslatableEnum.STORE_CATEGORY}
                                        items={[
                                            StoreCategory.PRODUCTS,
                                            StoreCategory.RESTAURANTS,
                                            StoreCategory.FLOWERS,
                                            StoreCategory.FOR_HOME,
                                            StoreCategory.FOR_CHILDREN,
                                            StoreCategory.CLOTHS_SHOES,
                                            StoreCategory.PETS,
                                            StoreCategory.BEAUTY_HEALTH,
                                            StoreCategory.SPORTS,
                                            StoreCategory.BUILDING,
                                            StoreCategory.FURNITURE,
                                            StoreCategory.SERVICES,
                                            StoreCategory.EDUCATION,
                                            StoreCategory.OTHER,
                                        ]}
                                    />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="tags"
                                        component={TagControlField}
                                        label={t('onboarding:storeDetails.tags')}
                                    />
                                </div>
                                <div className={classes.field}>
                                    <div className={classes.fieldClock}>
                                        <Text typography={TextTypography.PARA_ACCENT}>
                                            {t('onboarding:workingHours.title')}
                                        </Text>
                                        <div className={classes.fieldClockChange} style={{ width: 124, padding: 0 }}>
                                            <Field
                                                name="workingHours"
                                                component={WorkingHoursControlField}
                                                label={t('onboarding:storeDetails.workingHours')}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <Schedule storeSchedule={storeSchedule} />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.infoBlock}>
                                <Box mb={3}>
                                    <Text typography={TextTypography.TITLE_CHANGE}>
                                        {t('onboarding:storeDetails.contactsAndDetails')}
                                    </Text>
                                </Box>
                                <div className={classes.field}>
                                    <Field
                                        name="customUrl"
                                        component={TextControlField}
                                        autoCapitalize={'none'}
                                        label={t('onboarding:storeDetails.customUrl')}
                                        adornmentStart={`${new URL(getClientUrl()).host}/`}
                                    />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="website"
                                        component={TextControlField}
                                        autoCapitalize={'none'}
                                        label={t('onboarding:storeDetails.website')}
                                    />
                                </div>
                                {country !== SupportedCountryCodes.RUS && (
                                    <div className={classes.field} id="instagram">
                                        {idParams && (
                                            <Field
                                                autoFocus={idParams == 'instagram'}
                                                name="instagram"
                                                component={TextControlField}
                                                autoCapitalize={'none'}
                                                label={t('onboarding:storeDetails.instagram')}
                                            />
                                        )}
                                        {!idParams && (
                                            <Field
                                                name="instagram"
                                                component={TextControlField}
                                                autoCapitalize={'none'}
                                                label={t('onboarding:storeDetails.instagram')}
                                            />
                                        )}
                                    </div>
                                )}
                                {country !== SupportedCountryCodes.RUS && env.useInstagramFeature && (
                                    <Box>
                                        {hasInstagram ? (
                                            <Box mb={2}>
                                                {instagramPosts && instagramPosts.length > 0 && (
                                                    <InstagramGallery
                                                        condensed={true}
                                                        showTitle={false}
                                                        posts={instagramPosts}
                                                    />
                                                )}
                                            </Box>
                                        ) : (
                                            <Box textAlign="center" mb={2}>
                                                <Text typography={TextTypography.BODY_ACCENT}>
                                                    {t('onboarding:storeDetails.instagramDescription')}
                                                </Text>
                                            </Box>
                                        )}
                                        <Box mb={2}>
                                            <LargeButton
                                                color={hasInstagram ? LargeButtonColor.LIGHT : LargeButtonColor.SUCCESS}
                                                onClick={authorizeInstagram}
                                            >
                                                {hasInstagram
                                                    ? t('onboarding:storeDetails.instagramConnectNew')
                                                    : t('onboarding:storeDetails.instagramConnect')}
                                            </LargeButton>
                                        </Box>
                                        {hasInstagram && (
                                            <LargeButton
                                                color={LargeButtonColor.LIGHT}
                                                onClick={handleUpdateInstagramPosts}
                                            >
                                                {t('onboarding:storeDetails.instagramUpdatePosts')}
                                            </LargeButton>
                                        )}
                                    </Box>
                                )}
                                <div className={classes.linePhoto}>
                                    <HorizontalDivider />
                                </div>
                                <div className={classes.field}>
                                    <Field
                                        name="image"
                                        cropSize={{ width: 375, height: 187 }}
                                        cropAspect={2}
                                        component={StoreImageControlField}
                                        mode={CropperMode.DEFAULT}
                                        classNames={{
                                            imgClassName: classes.imgClassName,
                                        }}
                                        label={t('onboarding:storeDetails.coverImageLabel')}
                                        onChangeCrop={(crop: CroppedArea) => {
                                            props.onChangeImageCrop(crop);
                                        }}
                                    />
                                </div>
                                <div className={classes.field} style={{ textAlign: 'center' }}>
                                    <Text typography={TextTypography.PARA}>
                                        {t('onboarding:storeDetails.addImage')}
                                    </Text>
                                </div>
                            </div>
                        </div>
                        <Grid item xs={12} className={classes.frame}>
                            <Text typography={TextTypography.TITLE_CHANGE}>
                                {t('onboarding:storeDetails.storeDescription')}
                            </Text>

                            <Box pb={2} pt={3}>
                                <Text typography={TextTypography.PARA_CHANGE}>
                                    {t('onboarding:storeDetails.sloganDescriptionInfo')}
                                </Text>
                            </Box>
                            <div className={classes.field} id={'slogan'}>
                                {idParams && (
                                    <Field
                                        autoFocus={idParams == 'slogan'}
                                        name="slogan"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.sloganDescriptionValue,
                                            limit: 30,
                                        })}
                                        rows={3}
                                        maxLength={30}
                                        label={t('onboarding:storeDetails.sloganDescription')}
                                    />
                                )}
                                {!idParams && (
                                    <Field
                                        name="slogan"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.sloganDescriptionValue,
                                            limit: 30,
                                        })}
                                        rows={3}
                                        maxLength={30}
                                        label={t('onboarding:storeDetails.sloganDescription')}
                                    />
                                )}
                            </div>

                            <Box pb={2}>
                                <Text typography={TextTypography.PARA_CHANGE}>
                                    {t('onboarding:storeDetails.profitableProposition')}
                                </Text>
                            </Box>
                            <div className={classes.field} id={'sellingOffer'}>
                                {idParams && (
                                    <Field
                                        autoFocus={idParams == 'sellingOffer'}
                                        name="sellingDescription"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.sellingDescriptionValue,
                                            limit: 80,
                                        })}
                                        rows={3}
                                        maxLength={80}
                                        label={t('onboarding:storeDetails.sellingDescription')}
                                    />
                                )}
                                {!idParams && (
                                    <Field
                                        name="sellingDescription"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.sellingDescriptionValue,
                                            limit: 80,
                                        })}
                                        rows={3}
                                        maxLength={80}
                                        label={t('onboarding:storeDetails.sellingDescription')}
                                    />
                                )}
                            </div>
                            <div className={classes.line}>
                                <HorizontalDivider />
                            </div>

                            <Box pb={2}>
                                <Text typography={TextTypography.PARA_CHANGE}>
                                    {t('onboarding:storeDetails.shortDescriptionInfo')}
                                </Text>
                            </Box>
                            <div className={classes.field} id={'description'}>
                                {idParams && (
                                    <Field
                                        autoFocus={idParams == 'description'}
                                        name="shortDescription"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.shortDescriptionValue,
                                            limit: 200,
                                        })}
                                        rows={3}
                                        maxLength={200}
                                        label={t('onboarding:storeDetails.shortDescription')}
                                    />
                                )}

                                {!idParams && (
                                    <Field
                                        name="shortDescription"
                                        component={TextAreaControlField}
                                        helperText={t('onboarding:storeDetails.symbolsLimit', {
                                            enter: inputs.shortDescriptionValue,
                                            limit: 200,
                                        })}
                                        rows={3}
                                        maxLength={200}
                                        label={t('onboarding:storeDetails.shortDescription')}
                                    />
                                )}
                            </div>
                            <div className={classes.line}>
                                <HorizontalDivider />
                            </div>

                            <Box pb={2}>
                                <Text typography={TextTypography.PARA_CHANGE}>
                                    {t('onboarding:storeDetails.fullDescriptionInfo')}
                                </Text>
                            </Box>
                            <div className={classes.wysiwygField}>
                                <Field
                                    name="fullDescription"
                                    component={RichTextControlField}
                                    label={t('onboarding:storeDetails.fullDescription')}
                                />
                            </div>
                            <div className={classes.line}>
                                <HorizontalDivider />
                            </div>
                            <Box pb={2}>
                                <Text typography={TextTypography.PARA_CHANGE}>
                                    {t('onboarding:storeDetails.advantagesInfo')}
                                </Text>
                            </Box>
                            <div className={classes.field}>
                                <Field
                                    name="advantages"
                                    component={TextAreaControlField}
                                    helperText={t('onboarding:storeDetails.symbolsLimit', {
                                        enter: inputs.advantagesValue,
                                        limit: 150,
                                    })}
                                    rows={3}
                                    maxLength={150}
                                    label={t('onboarding:storeDetails.advantages')}
                                />
                            </div>
                        </Grid>

                        {error && (
                            <Grid item xs={12}>
                                <FormErrorMessage error={error} />
                            </Grid>
                        )}
                    </Grid>
                    <div className={classes.footerInfo}>
                        <div className={classes.editSubmit}>
                            <div style={{ marginRight: 8, width: '100%' }}>
                                <LargeButton
                                    disabled={!isUIEnabled}
                                    color={LargeButtonColor.LIGHT}
                                    onClick={goToVendorDashboard}
                                    type="submit"
                                >
                                    {t('onboarding:footer.close')}
                                </LargeButton>
                            </div>
                            <div style={{ marginLeft: 8, width: '100%' }}>
                                <LargeButton color={LargeButtonColor.SUCCESS} disabled={!isUIEnabled} type="submit">
                                    {t('common:addressDialog.save')}
                                </LargeButton>
                            </div>
                        </div>
                    </div>
                </form>
            </ErrorBoundary>
        );
    }
    return <FullScreenLoader />;
};

export const StoreVendorDetailsEditForm = connect(mapStateToEditFormProps)(
    reduxForm({
        form: Form.STORE_DETAILS_EDIT_FORM,
        enableReinitialize: true,
        validate: validator({
            name: string().required('common:validation.required'),
            storeCategory: string().nullable().required('common:validation.required'),
            phone: string()
                .nullable()
                .required('common:validation.required')
                .test({
                    message: 'common:validation.phoneFormat',
                    test: value => {
                        if (!value) {
                            return true;
                        }
                        return isPossiblePhoneNumber(value);
                    },
                }),
            customUrl: customUrlValidator,
        }),
        asyncValidate: makeAddressValidator(Form.STORE_DETAILS_EDIT_FORM, 'address'),
        asyncChangeFields: ['address', 'coordinates'],
    })(DefaultStoreDetailsForm),
);
